import { http } from "../api/http";
import Utils from "../utils";

export const auditLogService = {
  get,
  getById,
  getByUser,
  getByActionType,
  getByResource,
  getByClient,
  getFailedLogins,
};

// Main search endpoint with all filters
function get(requestParameters) {
  let url = `/auditlog?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Get single audit log by ID
function getById(auditLogId) {
  let url = `/auditlog/${auditLogId}`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Get logs by user ID
function getByUser(userId, limit = 100) {
  let url = `/auditlog/user/${userId}?limit=${limit}`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Get logs by action type
function getByActionType(actionType, limit = 100) {
  let url = `/auditlog/actiontype/${actionType}?limit=${limit}`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Get logs by resource
function getByResource(resourceType, resourceId, limit = 100) {
  let url = `/auditlog/resource/${resourceType}/${resourceId}?limit=${limit}`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Get logs by client
function getByClient(clientId, limit = 100) {
  let url = `/auditlog/client/${clientId}?limit=${limit}`;

  return http.get(url).then((response) => {
    return response;
  });
}

// Get failed logins
function getFailedLogins(requestParameters) {
  let url = `/auditlog/failedlogins`;

  if (requestParameters) {
    url += `?${Utils.objectToQueryString(requestParameters)}`;
  }

  return http.get(url).then((response) => {
    return response;
  });
}
